import { Flex } from '@chakra-ui/react';
import { Rabbit } from 'lucide-react';
import { CardEmptyState } from '../../../CardEmptyState';

export const GenericListingErrorState = () => (
  <Flex h="100%" justifyContent="center" w="100%">
    <CardEmptyState
      description={
        <>
          We encountered a problem trying to load the listing report.
          <br />
          Please check back later.
        </>
      }
      icon={Rabbit}
      title="Could Not Load Report"
    />
  </Flex>
);
